/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
  'embedded.confluence.already-logged-in-paragraph': '¿Has iniciado sesión? Prueba a actualizar.',
  'embedded.confluence.footer.hover.text': 'Ver en Confluence',
  'embedded.confluence.footer.prefix': 'Con tecnología de',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Iniciar sesión en Confluence',
  'embedded.confluence.login-page.login-button': 'Iniciar sesión en Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Botón de inicio de sesión',
  'embedded.confluence.login-page.login-text': 'Tienes que iniciar sesión para poder ver esta página',
  'embedded.confluence.login-page.refresh-page-banner':
    'Tras iniciar sesión, esta página debería actualizarse automáticamente. Si no, puedes hacer clic aquí para actualizar.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualizar página',
  'embedded.confluence.need-to-log-in-paragraph': 'Tienes que iniciar sesión para poder ver esta página',
  'embedded.confluence.still-having-trouble-paragraph':
    '¿Sigues teniendo problemas? Asegúrate de que las cookies de terceros están habilitadas o {link}',
  'embedded.confluence.troubleshooting-link-text': 'consulta esta guía de solución de problemas.',
  'embedded.confluence.troubleshooting-link.aria-label': 'enlace a la guía de solución de problemas',
};
